export const ordersStatus = {
  'canceled_order': '09',
  'created_order': '31',
  'assigned_technicians': '30',
  'wash_wait': '63',
  'closed_order': '80',
  'closed_order_not_billable': '85',
  'invoiced_order': '90',
  'anticipated_invoiced_order': '95',
  'dealers_orders': 'AA',
  'appraisals_orders': 'BB',
  'radio_invoice': '88',
  'quotations': '00',
};

export const tasksStatus = {
  'started_task': '40',
  'stopped_for_new_job': '50',
  'waiting_for_parts': '51',
  'waiting_for_approval': '52',
  'under_subcontract': '53',
  'end_of_day': '55',
  'detained_for_recess': '56',
  'finished_task': '60',
};

export const ordersTypes = {
  'AC': 'Accesorios',
  'DS': 'PDS',
  'CC': 'Control de Calidad',
  'DI': 'Hunter',
};

export const ordersTypesCodes = {
  'accessories': 'AC',
  'pds': 'DS',
  'quality_assurance': 'CC',
  'hunter': 'DI',
};

export const ordersColors = {
  '09': { // gray
    'background': '#E8E8E8',
    'color': '#707070',
  },
  '31': { // yellow
    'background': '#FFF8DC',
    'color': '#573A08',
  },
  '30': { // purple
    'background': '#F2EEf9',
    'color': '#473C8B',
  },
  '63': { // blue
    'background': '#F0F8FF',
    'color': '#306EFF',
  },
  '80': { // green
    'background': '#EEFDEC',
    'color': '#2C662D',
  },
  '85': { // gray
    'background': '#E8E8E8',
    'color': '#707070',
  },
};
